import Cookies from 'js-cookie';

const setupAjax = () => {
  function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
  }

  const csrftoken = Cookies.get('csrftoken');

  $.ajaxSetup({
    beforeSend: function (xhr, settings) {
      if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
        xhr.setRequestHeader('X-CSRFToken', csrftoken);
      }
    }
  });
};

const setupMenu = () => {
  // create sidebar and attach to menu open
  $('.ui.main.sidebar')
    .sidebar('attach events', '.toc.item');
  $('.ui.profile.sidebar')
    .sidebar('attach events', '.profile.item');
};

const setupSemanticProgressBars = () => {
  $('.progress').progress();
};

const setupSemanticSearchableDropdowns = ({ disableGlobalDropdownInit }) => {
  if (!disableGlobalDropdownInit) {
    $('.dropdown').addClass('search').dropdown({
      fullTextSearch: true,
    });
  }
};

const setupDisablingButttonsOnSubmit = () => {
  const globalFormID = '#main-form';
  const globalSubmitBtnID = '#form-submit';

  const form = $(globalFormID);
  const submitBtn = $(globalSubmitBtnID);

  form.on('submit', () => submitBtn.addClass('disabled'));
};

const registerGlobalScripts = (context) => {
  setupAjax();
  setupMenu();
  setupSemanticProgressBars();
  setupSemanticSearchableDropdowns(context);
  setupDisablingButttonsOnSubmit();
};

window.registerGlobalScripts = registerGlobalScripts;
